// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-size: 16px;
  box-sizing: border-box;
  font-family: "Manrope", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p {
  padding: 0;
  margin: 0;
}

button {
  text-transform: capitalize !important;
}

a {
  color: inherit;
  text-decoration: none;
}

input:-webkit-autofill {
  -webkit-background-clip: text !important;
}

input[type=number] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=date] {
  position: relative;
}

input[type=date]::-webkit-calendar-picker-indicator {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.arrow-down path {
  fill: #d22f31;
}

.white-stroke path {
  fill: #ffffff;
}

.green-stroke path {
  fill: #0b8149;
}

.dark-bg-visibility-off path {
  fill: #8e8e8e;
}

.mySwiper {
  height: 100%;
}

.otp:focus {
  outline: 1px solid #d22f31 !important;
}

.input-placeholder ::placeholder {
  font-size: 14px;
  letter-spacing: normal;
}

input:disabled {
  -webkit-text-fill-color: #000000 !important;
}

.MuiAutocomplete-popper {
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 0 1px #d22f31;
  border-top: none;
}

.css-2zzrin-MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true].Mui-focused {
  background-color: rgba(210, 47, 49, 0.2) !important;
}

.css-2zzrin-MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] {
  background-color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,UAAA;EACA,SAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;;EAEE,wBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AACF;;AAGE;EACE,aAAA;AAAJ;;AAKE;EACE,aAAA;AAFJ;;AAOE;EACE,aAAA;AAJJ;;AASE;EACE,aAAA;AANJ;;AAUA;EACE,YAAA;AAPF;;AAYE;EACE,qCAAA;AATJ;;AAeE;EACE,eAAA;EACA,sBAAA;AAZJ;;AAiBA;EACE,2CAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;AAdF;;AAiBA;EAEE,mDAAA;AAfF;;AAkBA;EAEE,oCAAA;AAhBF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  box-sizing: border-box;\n  font-family: \"Manrope\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\np {\n  padding: 0;\n  margin: 0;\n}\n\nbutton {\n  text-transform: capitalize !important;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\ninput:-webkit-autofill {\n  -webkit-background-clip: text !important;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type=\"date\"] {\n  position: relative;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.arrow-down {\n  path {\n    fill: #d22f31;\n  }\n}\n\n.white-stroke {\n  path {\n    fill: #ffffff;\n  }\n}\n\n.green-stroke {\n  path {\n    fill: #0b8149;\n  }\n}\n\n.dark-bg-visibility-off {\n  path {\n    fill: #8e8e8e;\n  }\n}\n\n.mySwiper {\n  height: 100%;\n}\n\n// OTP styles\n.otp {\n  &:focus {\n    outline: 1px solid #d22f31 !important;\n  }\n}\n\n// input-placeholder\n.input-placeholder {\n  ::placeholder {\n    font-size: 14px;\n    letter-spacing: normal;\n  }\n}\n\n// disabled input\ninput:disabled {\n  -webkit-text-fill-color: #000000 !important;\n}\n\n.MuiAutocomplete-popper {\n  background-color: #ffffff;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 0 1px #d22f31;\n  border-top: none;\n}\n\n.css-2zzrin-MuiAutocomplete-listbox\n  .MuiAutocomplete-option[aria-selected=\"true\"].Mui-focused {\n  background-color: rgba(210, 47, 49, 0.2) !important;\n}\n\n.css-2zzrin-MuiAutocomplete-listbox\n  .MuiAutocomplete-option[aria-selected=\"true\"] {\n  background-color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
